<template>
    <div>

        <TextBanner>
        <p>Auffällig an der ISS sind die acht großen <b>Solarmodule</b>, die aus je zwei einzelnen Auffangflächen bestehen.</p>
        <b>Aktivieren Sie die Solarpanels mit einem Klick auf den orangen Punkt, und versorgen Sie so die komplette Raumstation mit Energie.</b> 
        </TextBanner>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_030_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_030_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>

        </Fallback>


    </div>
</template>

<script>
export default {
    name: 'infobox',
    babylonState: {
        camera: {
            position: [.48,.88,27],       //-0.67,1.35,45               //Alternative nah: .48,.88,27 
            target: [10,-2,1],              //target: [10,-2,1
            //fov: 1.5,

            //alphaLimits: [null, null],
            //betaLimits: [null, null],
            useAutoRotationBehavior: true,
            idleRotationSpeed: -0.004,
        },


        iss: {


            Thermo_Control_rechts: {
                pickable: false
            },

            Thermo_Control_links: {
                pickable: false
            },

            Hauptstrebe: {
                pickable: false
            },

            // Rotationsgelenk_rechts: {
            //     Panel_4_rechts: {
            //             Solarpanels_gross_005: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_3_rechts: {
            //             Solarpanels_gross_004: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_2_rechts: {
            //             Solarpanels_gross_007: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_1_rechts: {
            //             Solarpanels_gross_006: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },
            // },
            // Rotationsgelenk_links: {
            //     Panel_4_links: {
            //             Solarpanels_gross_003: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_3_links: {
            //             Solarpanels_gross_002: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_2_links: {
            //             Solarpanels_gross_001: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },

            //     Panel_1_links: {
            //             Solarpanels_gross: {
            //                 overlayColor: [220/255, 52/255, 109/255],
            //                 overlayAlpha: 0.6
            //             }
            //     },
            // }
        },

        hotspots: {

            // thermo_beide: {
            //     visible: true,
            //     position: [-3, -1, 0],
            //     scale: 2,
            //     renderingGroupId: 0,
            //     // Aktion ausführen
            //     trigger: (babylonController) => {
            //         babylonController.startAnimation("thermo_rechts_anim", false, 1);
            //         babylonController.startAnimation("thermo_links_anim", false, .4);

            //      }
            // },

            solarpanels: {
                visible: true,
                position: [14,.5,2],  //[8,2,10        //Alternative Nah:15,1,2.5
                scale: 3,              //8             //Alternative Nah: 3
                renderingGroupId: 0,
                // Aktion ausführen
                trigger: (babylonController) => {
                    babylonController.startAnimation("Solarpanels_rechts_anim", false, .3);     //.4
                    babylonController.startAnimation("Solarpanels_links_anim", false, .4);     //.25
                    //babylonController.startAnimation("thermo_rechts_anim", false, 1);
                    //babylonController.startAnimation("thermo_links_anim", false, .4);
                    // babylonController.startAnimation("Panel_1_rechts_anim", false, .175);
                    // babylonController.startAnimation("Panel_2_rechts_anim", false, .1);
                    // babylonController.startAnimation("Panel_3_rechts_anim", false, .2);
                    // babylonController.startAnimation("Panel_4_rechts_anim", false, .13);
                    // babylonController.startAnimation("Panel_1_links_anim", false, .1);
                    // babylonController.startAnimation("Panel_2_links_anim", false, .2);
                    // babylonController.startAnimation("Panel_3_links_anim", false, .15);
                    // babylonController.startAnimation("Panel_4_links_anim", false, .2);

                },

            },
        },

    },
    babylonReady: function () {
        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);
       
       this.$babylonController.goToAnimation("spacex_anim", 0);

        this.$babylonController.timer.add(200, () => {     //1300
            this.$babylonController.setCameraRadiusLimit(11,200);
        });

        
        // this.$babylonController.goToAnimation("Solarpanels_rechts_anim", 0);
        // this.$babylonController.goToAnimation("Solarpanels_links_anim", 0);
        // this.$babylonController.goToAnimation("thermo_rechts_anim", 0);
        // this.$babylonController.goToAnimation("thermo_links_anim", 0);
        // this.$babylonController.goToAnimation("Panel_1_rechts_anim", 0);
        // this.$babylonController.goToAnimation("Panel_2_rechts_anim", 0);
        // this.$babylonController.goToAnimation("Panel_3_rechts_anim", 0);
        // this.$babylonController.goToAnimation("Panel_4_rechts_anim", 0);
        // this.$babylonController.goToAnimation("Panel_1_links_anim", 0);
        // this.$babylonController.goToAnimation("Panel_2_links_anim", 0);
        // this.$babylonController.goToAnimation("Panel_3_links_anim", 0);
        // this.$babylonController.goToAnimation("Panel_4_links_anim", 0)


    },
}
</script>

<style scoped lang="scss">

    // url /#/hotspots?fallback=true

    .fallback-container {
        // background-color: rgba(red, .5); // demo: contain vs. cover
    }
    .fallback-container img {
        object-fit: contain; // default: cover
        object-position: center; // default: center
    }
    .fallback-container .hotspot--links {
        top: 20vh;
        left: 25vw;

        @media (orientation: landscape) {
            // optional: change position
            left: 15vw;
        }
    }
    .fallback-container .hotspot--rechts {
        top: 30vh;
        left: 60vw;
        transform: scale(0.75); // optional: scale hotspot

        @media (orientation: landscape) {
            // optional: change position
            top: 15vh;
        }
    }

</style>
